/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2025 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import { registerAssetsBatch, updateAssetsBatch } from '@/services/asset-batches'
import { useState, useRef } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { useNavigate } from 'react-router-dom'
import { assetsBatchesUrls } from '@/configs/urls'

const useUploadForm = ({ assetsBatch, setError, setHasAlert }) => {
  const navigate = useNavigate()
  const fileInputRef = useRef(null)
  const [fileInfo, setFileInfo] = useState()
  const [uploadDisabled, setUploadDisabled] = useState(true)
  const [fileError, setFileError] = useState()
  const { getAccessTokenSilently: getAccessToken } = useAuth0()

  const onSubmit = async data => {
    try {
      const { csvFile, name } = data
      const formData = new FormData()

      csvFile[0] &&
        formData.append('file', csvFile[0])
      formData.append('name', name)
      !formData.get('file') &&
        setFileError('The file is required')

      const response = assetsBatch?.id
        ? await updateAssetsBatch({ id: assetsBatch.id, formData }, getAccessToken)
        : await registerAssetsBatch(formData, getAccessToken)
      if (response?.id) {
        assetsBatch?.id
          ? navigate(0)
          : navigate(`/${assetsBatchesUrls.base}`, { replace: true })
      }
    } catch (error) {
      setHasAlert && setHasAlert(true)
      setError('csvFile', {
        type: 'server',
        message: error.response.data.message
      })
    }
  }
  const handleOnChange = (e) => {
    const selectedFile = e.target.files[0]

    if (selectedFile) {
      setFileInfo({ name: selectedFile.name })
      setUploadDisabled(false)
    }
  }

  const handleDeleteFile = () => {
    setFileInfo(null)
    setUploadDisabled(true)

    if (fileInputRef.current) {
      fileInputRef.current.value = ''
    }
  }

  const validateCSV = (file) => {
    if (!file) return false

    return file[0].type === 'text/csv' ||
      file[0].name.toLowerCase().endsWith('.csv')
      ? true
      : 'The file is not a csv file, please upload a csv file.'
  }

  return {
    fileError,
    fileInfo,
    fileInputRef,
    handleDeleteFile,
    handleOnChange,
    onSubmit,
    uploadDisabled,
    validateCSV
  }
}

export default useUploadForm
